import { useMemo, useState } from 'react';
import { Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';

import { TicketsPrice } from '../../../components/tickets-price/tickets-price';
import { PassengersAddControl } from './passengers-add-control';
import { MyPassenger } from './types';

type AddPassengersProps = {
  tariffs: any;
  tripStartTime: string;
  onChange: (pass: MyPassenger[]) => void;
};

export const AddPassengers = observer(
  ({ tariffs, tripStartTime, onChange }: AddPassengersProps) => {
    const [selectedTariffs, setSelectedTariffs] = useState<MyPassenger[]>([]);

    const calculatedTariffs = useMemo(
      () => selectedTariffs.flatMap((pass) => pass.tariffs),
      [selectedTariffs]
    );

    const handleSelectSeats = (pass: MyPassenger[]) => {
      setSelectedTariffs(pass);
      onChange(pass);
    };

    return (
      <Stack spacing="sm">
        <PassengersAddControl tariffs={tariffs} onChange={handleSelectSeats} />

        <TicketsPrice
          tripStartTime={tripStartTime}
          selectedTariffs={calculatedTariffs}
        />
      </Stack>
    );
  }
);
